import styled from 'styled-components/native';

import ImageBackground from '@src/components/ImageBackground';

export const Background = styled(ImageBackground).attrs({
  resizeMode: 'contain',
})`
  width: 100%;
  height: 500px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
